module.exports = __webpack_public_path__ + "img/1585412444.67b674e3.jpg";